// Copia local (en este navegador) del avance del test. El servidor sigue siendo la
// copia principal, pero si la red corta los guardados la persona no pierde lo
// respondido al recargar: se retoma desde la copia más reciente de las dos.
//
// Cada snapshot lleva `rev`, un contador que sube con cada guardado y viaja también
// al servidor, para saber cuál de las dos copias es la más nueva.

const keyFor = (collaboratorTestID) => `growme-test-progress:${collaboratorTestID}`;

// localStorage puede no existir o fallar (modo privado, cuota llena): nunca debe
// romper el test, solo se pierde la copia local.
export const readLocalProgress = (collaboratorTestID) => {
  try {
    const raw = localStorage.getItem(keyFor(collaboratorTestID));
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const writeLocalProgress = (collaboratorTestID, progress) => {
  try {
    localStorage.setItem(keyFor(collaboratorTestID), JSON.stringify(progress));
  } catch (error) {
    console.warn('No se pudo guardar el avance del test en este navegador', error);
  }
};

export const clearLocalProgress = (collaboratorTestID) => {
  try {
    localStorage.removeItem(keyFor(collaboratorTestID));
  } catch (error) {
    // Sin acceso a localStorage no hay nada que limpiar.
  }
};

const revOf = (progress) => (Number.isInteger(progress?.rev) ? progress.rev : 0);

// La copia local gana solo si es estrictamente más nueva: ante empate (o snapshots
// de antes de este cambio, sin rev) manda el servidor, que además trae los tiempos.
export const pickLatestProgress = (serverProgress, localProgress) => {
  if (!localProgress) return { progress: serverProgress || null, fromLocal: false };
  if (!serverProgress) return { progress: localProgress, fromLocal: true };
  return revOf(localProgress) > revOf(serverProgress)
    ? { progress: localProgress, fromLocal: true }
    : { progress: serverProgress, fromLocal: false };
};

export const maxRev = (...snapshots) => Math.max(0, ...snapshots.map(revOf));
